import { Col, Row } from 'reactstrap';
import Dashboard from '@g17eco/molecules/dashboard';
import { AdminSettingsCard, AdminSettingsCardProps } from './AdminSettingsCard';
import './styles.scss';

export interface AdminSettingSection {
  label: string;
  cards: AdminSettingsCardProps[];
}

interface Props {
  sections: AdminSettingSection[];
}
export const AdminSettings = ({ sections }: Props) => {

  return (
    <Dashboard>
      {sections.map((section) => (
        <div key={section.label} className='mb-4'>
          <h3 className='text-ThemeHeadingMedium mt-0 mb-3'>{section.label}</h3>
          <Row className='admin-settings-container-v2 px-2'>
            {section.cards
              .filter((card) => !card.isHidden)
              .map((card) => (
              <Col key={card.id ?? card.text?.toString()} className='col-12 col-sm-6 col-lg-4'>
                <AdminSettingsCard {...card} />
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </Dashboard>
  );
};
